import { EntityType } from '@shared/models/entity-enum';

export interface FormStateModel {
  showFavorites: boolean;
  beastMode: boolean;
  collapseAll: boolean;
}

export interface FormViewStateModel {
  isCreateMode?: boolean;
  viewStatus: { [key: string]: FormStateModel };
  favorites?: { [key: number]: boolean };
  activeEntity?: EntityType;
  expandedSections?: { [key: string]: boolean };
}

export interface FavoritesMap {
  [key: number]: boolean;
}
export interface FavoriteOptions {
  isCreateMode?: boolean;
  showFavorites: boolean;
  favorites: FavoritesMap;
  activeEntity?: EntityType;
}
